import React from 'react';
import {
  AppBar,
  Toolbar,
  Grid,
  Container,
  makeStyles,
  useMediaQuery,
  Menu,
  MenuItem,
  IConButton,
  Badge,
} from '@material-ui/core';

import FacebookIcon from '@material-ui/icons/Facebook';
import { Link } from 'react-scroll';
import { Link as GLink } from 'gatsby';

import BusinessIcon from '@material-ui/icons/Business';
import IconButton from '@material-ui/core/IconButton';
import MailIcon from '@material-ui/icons/Mail';
import MenuIcon from '@material-ui/icons/Menu';
import TheatersIcon from '@material-ui/icons/Theaters';

const useStyles = makeStyles((theme) => ({
  appBar: {
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    color: '#808080',
    borderColor: '#e1e1e1',
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
  },
  menu: {
    height: '88px',
    textAlign: 'center',
    marginRight: '36px',
    lineHeight: '88px',
    color: '#333333',
    fontWeight: '600',
    fontSize: '13px',
    float: 'left',
    '&:hover': {
      color: '#00aaff',
    },
  },
  logo: {
    paddingTop: '8px',
    '&:hover': {
      color: '#00aaff',
    },
    float: 'left',
    height: '100%',
  },
  sectionDesktop: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
  },
  sectionMobile: {
    textAlign: 'right',
    marginTop: '15px',
    marginLeft: '10px',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  siteLogo: {
    maxWidth: '200px',
    maxHeight: '80px',
  },
  appleAuthorizedLogo: {
    textAlign: 'right',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '88px',
    '& img': {
      height: '34.13px',
      width: 'auto',
    },
    position: 'absolute',
    right: '20px',
  },
}));

const useHeader = (props) => {
  const classes = useStyles();

  /**
   * 반응형
   */
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);

  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const menuId = 'primary-search-account-menu';

  const mobileMenuId = 'primary-search-account-menu-mobile';
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <Link
        to="company"
        activeClass="active"
        spy={true}
        smooth={true}
        duration={500}
        offset={-80}
        style={{
          cursor: 'pointer',
        }}
        onClick={handleMobileMenuClose}
      >
        <MenuItem>
          <IconButton color="inherit">
            <BusinessIcon />
          </IconButton>

          <p>COMPANY</p>
        </MenuItem>{' '}
      </Link>

      <Link
        to="digitalMedia"
        activeClass="active"
        spy={true}
        smooth={true}
        duration={500}
        offset={-80}
        style={{
          cursor: 'pointer',
        }}
        onClick={handleMobileMenuClose}
      >
        <MenuItem>
          <IconButton color="inherit">
            <TheatersIcon />
          </IconButton>

          <p>DIGITAL MEDIA</p>
        </MenuItem>
      </Link>
      <Link
        to="contactUs"
        activeClass="active"
        spy={true}
        smooth={true}
        duration={500}
        offset={-80}
        style={{
          cursor: 'pointer',
        }}
        onClick={handleMobileMenuClose}
      >
        <MenuItem>
          <IconButton color="inherit">
            <MailIcon />
          </IconButton>

          <p>CONTACT US</p>
        </MenuItem>
      </Link>
      <a
        style={{
          textDecoration: 'none',
          color: 'black',
        }}
        href="https://www.facebook.com/malgntech2001/"
        target="_blank"
      >
        <MenuItem>
          <IconButton color="inherit">
            <FacebookIcon />
          </IconButton>
          <p>FACEBOOK</p>
        </MenuItem>
      </a>
    </Menu>
  );

  return (
    <>
      <AppBar className={classes.appBar} elevation={0}>
        <Toolbar>
          <Container maxWidth="md">
            <Grid container>
              <Grid item xs={6}>
                <GLink to="/">
                  <img
                    className={classes.siteLogo}
                    src="/img/logo/malgn_logo21.png"
                    alt="MALGN"
                  />
                </GLink>
              </Grid>

              <Grid item xs={6}>
                <div className={classes.sectionDesktop}>
                  <Link
                    className={classes.menu}
                    to="company"
                    activeClass="active"
                    spy={true}
                    smooth={true}
                    duration={500}
                    offset={-80}
                    style={{
                      cursor: 'pointer',
                    }}
                  >
                    <span>COMPANY</span>
                  </Link>
                  <Link
                    className={classes.menu}
                    to="digitalMedia"
                    activeClass="active"
                    spy={true}
                    smooth={true}
                    duration={500}
                    offset={-80}
                    style={{
                      cursor: 'pointer',
                    }}
                  >
                    <span>DIGITAL MEDIA</span>
                  </Link>
                  <Link
                    className={classes.menu}
                    to="contactUs"
                    activeClass="active"
                    spy={true}
                    smooth={true}
                    duration={500}
                    offset={-80}
                    style={{
                      cursor: 'pointer',
                    }}
                  >
                    <span>CONTACT US</span>
                  </Link>
                  <a
                    style={{
                      textDecoration: 'none',
                      color: 'black',
                      marginTop: '23px',
                    }}
                    href="https://www.facebook.com/malgntech2001/"
                    target="_blank"
                  >
                    <div className={classes.logo}>
                      <FacebookIcon />
                    </div>
                  </a>
                  <div className={classes.appleAuthorizedLogo}>
                    <img
                      src="/img/digital-media/apple/Apple_Authorized_2-removebg.png"
                      alt="Apple_Authorized"
                    />
                  </div>
                </div>

                <div className={classes.sectionMobile}>
                  <IconButton
                    aria-label="show more"
                    aria-controls={mobileMenuId}
                    aria-haspopup="true"
                    onClick={handleMobileMenuOpen}
                    color="inherit"
                  >
                    <MenuIcon fontSize="large" />
                  </IconButton>
                </div>
              </Grid>
            </Grid>
          </Container>
        </Toolbar>
      </AppBar>

      {renderMobileMenu}
    </>
  );
};

export default useHeader;
